import React from 'react'
import '../styles/Editor.css'

const UserMangUpdate = () => {
  return (
    <header className='headerEditor'>
      <h2>
        Update Your User Management
        </h2>      
    </header>
  )
}

export default UserMangUpdate